const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY

export const GOOGLE_MAP_API_URL = `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${GOOGLE_API_KEY}`

export const GOOGLE_MAP_STATIC_URL = `https://maps.googleapis.com/maps/api/staticmap?center={LOCATION}&zoom=12&size=${
  window.outerWidth - 32
}x100&maptype=roadmap&markers=color:red%7C{LOCATION}&key=${GOOGLE_API_KEY}`

export const GOOGLE_MAP_ADDRESS = `https://maps.googleapis.com/maps/api/geocode/json?latlng={LOCATION}&key=${GOOGLE_API_KEY}`

export * from './provinces.json'

export const HeroType = {
  RECYCLE_SHOP: {
    radius: 1000
  },
  SCOOTER: {
    radius: 5000
  },
  DROP_POINT: {
    radius: 500
  },
  POSTAL: {
    radius: 0
  },
  CIRCULAR_BIN: {
    radius: 500
  }
}

export const DEFAULT_LOCATION = {
  lat: 18.79108,
  lng: 98.9833963
}



// WEBPACK FOOTER //
// ./src/config/index.js